// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aX","message":"aY","header":"aZ","subHeading":"a0","buttons":"a1","buttonWrapper":"a2","btn":"a3"};